import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { API } from "aws-amplify";
import { ToastContainer } from "react-toastify";
import { useHistory } from "react-router-dom";

import { openModalImproveRate } from "../Store/improveRate/actions";
import {
  modalSteps,
  resetRedux,
  stateAlert,
} from "../Store/simulate/actions";
import { decryptEstandar } from "../Utils/CryptographyUtils";
import { handleState } from "../Utils/utils";

import TitleHeader from "./titleHeader";
import BreadCrumbs from "./BreadCrumbs";
import Tabs from "../Components/FormElements/tabs";
import Pagination from "../Components/FormElements/pagination";
import TotalTable from "../Components/FormElements/totalTable";
import CardTablaTmp from "../Components/FormElements/CardTablaTmp";
import ModalFiltering from "../Components/FormElements/ModalFiltering";
import Button from "../Components/FormElements/Button";
import AlertNotifications from "../Components/FormElements/AlertNotifications";
import TableAprovations from "../Components/FormElements/tableAprovations";

import ModalMessage from "../Components/modalMessage";
import ModalConfirm from "../Components/modalConfirm";
import ModalImproveRate from "../Components/modalImproveRate";
import SpinnerTable from "../Components/SpinnerTable";
import Loading from "../Components/loading";
import Footer from "../Components/Footer";

import GirlImage from "../Resources/svg/human/GirlImage";
import IconBack from "../Resources/svg/Icons/IconBack";
import IconFilter from "../Resources/svg/Icons/IconFilter";
import IconDelete from "../Resources/svg/Icons/IconDelete";
import IconErrorLight from "../Resources/svg/Icons/IconErrorLight";

import { weftType } from '../Utils/constants';
import ModalSide from "./wizard/FormElements/ModalSide";
import Chip from "./wizard/FormElements/Chip";
import { InputsSearchByAprovation } from "./wizard/FormElements/InputsSearchByAprovation";
import { productDictionary } from "../../src/Utils/constants.js";

export default function ListAprovations() {
  const history = useHistory();
  const channel = useSelector((state) => state.login.channel);
  const asesorSel = useSelector((state) =>
    decryptEstandar(state.login.idClient)
  );
  const availableProducts = useSelector((state) => state.login.access_configuration.availableProducts);
  const listProducts = availableProducts.map(product => productDictionary[product]);

  const [searchInput, setSearchInput] = useState("");
  const [searchType, setSearchType] = useState("documento");
  const [activeState, setActiveState] = useState("todas");
  const [modalData, setModalData] = useState({});
  const [activeProduct, setActiveProduct] = useState(listProducts[0].name);
  const [activeProductCode, setActiveProductCode] = useState(listProducts[0].code);
  const [openModal, setOpenModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [keyPages, setKeyPages] = useState(null);

  const [tableQuote, setTableQuote] = useState([]);
  const [loading, setLoading] = useState(false);

  const [openModalConfirm, setOpenModalConfirm] = useState(false);
  const [dataModalConfirm, setDataModalConfirm] = useState(null);
  const [messageConfirm, setMessageConfirm] = useState("");
  const [openModalMessage, setOpenModalMessage] = useState(false);
  const [message, setMessage] = useState("");
  const [typeMessage, setTypeMessage] = useState("");
  const [itemModalImproveRate, setItemModalImproveRate] = useState(null);

  const loadingInproveRate = useSelector((state) => state.improveRate.loading);
  const rate = useSelector((state) => state.improveRate.rate);
  const isOpenModalImproveRate = useSelector(
    (state) => state.improveRate.isOpen
  );
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState({});

  const [params, setParams] = useState({
    page: 1,
    limit: 6,
    state: "todas",
    codProd: activeProductCode,
    haveKey: false,
    keyPage: null,
    emailAdviser: selectedOption.value || null,
    channel: channel,
  });

  const [withParams, setWithParams] = useState(false);

  const timerToClear = useRef(false);
  const limitPage = 6;

  const options = {
    documento: "DNI/CE",
    nombres: "Nombres y apellidos",
  };

  const handleChangeSearch = (event) => {
    const val = event.target.value;
    let validateNumber = /^([0-9])*$/.test(val);
    if (searchType === "documento") {
      if (!validateNumber) {
        return false;
      }
    }
    setSearchInput(val.toUpperCase());

    clearTimeout(timerToClear.current);
    timerToClear.current = setTimeout(() => {
      const data = {
        ...params,
        page: 1,
        haveKey: false,
      };
      delete data["filter"];
      if (val !== "") {
        data.filter = {
          key: searchType,
          value: val.toUpperCase(),
        };
      }
      setParams(data);
    }, 1000);
  };

  const handleChangeSelect = (event) => {
    const val = event.target.value;
    setSearchInput("");
    setSearchType(val);
  };

  const handleChangeState = (event) => {
    const val = event.target.value;
    setActiveState(val);
    setParams({
      ...params,
      page: 1,
      state: val,
      haveKey: false,
      keyPage: null,
    });
  };

  const handleClickProduct = (val) => {
    setActiveProduct(val);
    let code = listProducts.filter((obj) => {
      return obj.name === val;
    })[0].code;
    setActiveProductCode(code);
    setParams({
      ...params,
      page: 1,
      codProd: code,
      haveKey: false,
      keyPage: null,
    });
  };

  const setCustomPage = (page) => {
    if (currentPage !== page) {
      setCurrentPage(page);
      setParams({
        ...params,
        page: page,
        haveKey: true,
        keyPage: keyPages[page - 2] || null,
      });
    }
  };

  const handleReset = () => {
    document
      .querySelectorAll('input[type="input"]')
      .forEach((x) => (x.value = ""));
    document
      .querySelectorAll("select")
      .forEach((x) => (x.options.selectedIndex = 0));
    params.emailAdviser = asesorSel;
    setSearchInput("");
    setSearchType("");
    const data = {
      ...params,
      page: 1,
      haveKey: false,
      keyPage: null,
    };
    delete data["filter"];
    data.filter = {
      key: searchType,
      value: "",
    };
    setParams(data);
  };

  const getQuotes = async () => {
    setLoading(true);
    setWithParams(params.filter && params.filter.value);

    const request = {
      body: params,
    };
    const response = await API.post("api-rentas", "/cotizaciones", request);
    const { data, last_page, total, keys } = response;
    setCurrentPage(params.page);
    setTableQuote(data);
    if (keys) {
      setLastPage(last_page);
      setTotalItems(total);
      setKeyPages(keys);
    }
    setLoading(false);
  };

  useEffect(() => {
    getQuotes();
  }, [params, rate]);
  const closeModalImproveRate = () => dispatch(openModalImproveRate(false));

  const processReactiveSimulation = async (data) => {
    const { item, index } = data;
    const isAdmin = channel === "admin";
    setLoading(true);
    const response = await API.post("api-rentas", "/activate-simulation", {
      body: { simulationId: item.idSimulacion, isAdmin },
    });
    setLoading(false);
    setMessage(response.message);
    setTypeMessage(response.status ? "success" : "error");
    setOpenModalMessage(true);
    if (response.status) {
      const newData = [...tableQuote];
      newData[index].estado = "Vigente";
      newData[index].datosSimulacion.vencimiento =
        response.data.expirationFormat;
      setTableQuote(newData);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      dispatch(stateAlert(false));
    }, 7000);
    dispatch(resetRedux());
  }, []);

  const handleStateClose = () => {
    document
      .querySelectorAll("select")
      .forEach((x) => (x.options.selectedIndex = 0));

    setParams({
      ...params,
      state: "todas",
    });
  };

  const handleAsesorClose = () => {
    setSelectedOption({
      label: "",
      value: "",
    });

    document
      .querySelectorAll('input[type="input"]')
      .forEach((x) => (x.value = ""));
    setSearchInput("");
    const data = {
      ...params,
      page: 1,
      haveKey: false,
      keyPage: null,
    };
    delete data["filter"];
    data.filter = {
      key: searchType,
      value: "",
    };
    setParams({
      ...params,
      emailAdviser: "",
    });
  };

  return (
    <div>
      <div className="sectionSearch">
        <div className="wrap">
          <div className="content-box">
            <BreadCrumbs rutas={[{ link: "Aprobaciones" }]} />
            <div className="back-responsive">
              <div className="back-responsive__box">
                <IconBack
                  className="nav-case__back"
                  onClick={() => history.push(-1)}
                />
                <div className="back-responsive__text">Volver</div>
              </div>
            </div>
            <TitleHeader
              title="Listado de aprobaciones"
              titleBold=""
              subtitle="Revisa las aprobaciones que han sido enviadas"
            />
          </div>
        </div>
      </div>
      <div className="sectionTable">
        <div className="wrap">
          <div className="content-box">
            <div className="sectionTable__text">Busca por:</div>
            <div className="filter" onClick={() => dispatch(modalSteps(true))}>
              <IconFilter />
              <div className="filter__text">Filtrar</div>
            </div>
            <div className="chip-content">
              {params.state !== "todas" && (
                <Chip
                  label={handleState(params.state)}
                  handleCloseChip={handleStateClose}
                  variant="filtro"
                />
              )}
              {searchInput.length > 1 && (
                <Chip
                  label={searchInput}
                  handleCloseChip={handleAsesorClose}
                  variant="asesor"
                />
              )}
            </div>
            <div className="list-quote-form">
              <InputsSearchByAprovation
                handleChangeState={handleChangeState}
                channel={channel}
                params={params}
                setParams={setParams}
                options={options}
                searchInput={searchInput}
                handleChangeSearch={handleChangeSearch}
                handleChangeSelect={handleChangeSelect}
                codProd={activeProductCode}
                selectedOption={selectedOption}
                setSelectedOption={setSelectedOption}
              />
            </div>
          </div>
          <Tabs
            values={listProducts.flatMap(({ name }) => name).join()}
            onClick={handleClickProduct}
            activeState={activeProduct}
          />
          <div className="content-box">
            {loading && (
              <>
                <SpinnerTable
                  title="¡Danos un momento!"
                  subtitle="Se está cargando la información."
                />
              </>
            )}
            {!loading && tableQuote.length > 0 && (
              <>
                <TotalTable limitPage={limitPage} totalItems={totalItems} />
                <div className="tab-shadow">
                  <TableAprovations
                    data={tableQuote}
                    codProd={activeProductCode}
                    setModalData={setModalData}
                  />
                </div>
                {tableQuote.map((datos, index) => (
                  <CardTablaTmp
                    data={datos}
                    codProd={activeProductCode}
                    key={index}
                    setModalData={setModalData}
                    variant={"aprobacion"}
                  />
                ))}
                <Pagination
                  currentPage={currentPage}
                  lastPage={lastPage}
                  setCurrentPage={setCustomPage}
                />
              </>
            )}
            {!loading && tableQuote.length < 1 && !withParams && (
              <div className="tableMessage">
                <IconErrorLight className="tableMessage__img" />
                <div className="tableMessage__empty">¡Ups! Lo sentimos.</div>
                <div className="tableMessage__message">
                  No encontramos resultados para tu búsqueda. Por favor,
                  verifica que el dato sea correcto.
                </div>
              </div>
            )}
            {!loading && tableQuote.length < 1 && withParams && (
              <div className="tableMessage">
                <GirlImage className="tableMessage__img" />
                <div className="tableMessage__empty">¡Lo sentimos!</div>
                <div className="tableMessage__message">
                  No encontramos resultados para el Nº de documento que
                  ingresaste. <br></br>
                  Revisa que sea el correcto o ingresa uno válido.
                </div>
              </div>
            )}
            {loadingInproveRate && <Loading />}
            <ToastContainer containerId={"A"} />
          </div>
        </div>
      </div>
      <ModalFiltering
        className="modal-result is-fullscreen"
        open={openModal}
        setOpenModal={setOpenModal}
      >
        <h2 className="modal-result__title">Filtra tu búsqueda</h2>
        <div className="modal-result__desc">
          <InputsSearchByAprovation
            handleChangeState={handleChangeState}
            channel={channel}
            params={params}
            setParams={setParams}
            options={options}
            searchInput={searchInput}
            handleChangeSearch={handleChangeSearch}
            handleChangeSelect={handleChangeSelect}
            codProd={activeProductCode}
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
          />
        </div>
        <div className="actions">
          <div className="actions__clean">
            <IconDelete />
            <div className="actions__text" onClick={handleReset}>
              Limpiar
            </div>
          </div>
          <Button
            className="actions__btn"
            onClick={() => dispatch(modalSteps(false))}
          >
            Buscar
          </Button>
        </div>
      </ModalFiltering>
      <ModalMessage
        open={openModalMessage}
        setOpen={setOpenModalMessage}
        message={message}
        type={typeMessage}
      />
      <ModalConfirm
        open={openModalConfirm}
        setOpen={setOpenModalConfirm}
        title="Activar simulación"
        message={messageConfirm}
        data={dataModalConfirm}
        acceptCallback={processReactiveSimulation}
      />
      <ModalImproveRate
        open={isOpenModalImproveRate}
        close={() => closeModalImproveRate()}
        item={itemModalImproveRate}
      />
      <ModalSide
        modalData={modalData}
        title="Cotización"
        subtitle="Visualiza los detalles de la cotización."
        stateTitle={true}
        weftType={ weftType.aprovations }
      />
      <AlertNotifications />
      <Footer />
    </div>
  );
}
